import React, { memo } from 'react';
import RltdContentsSection from '@wconcept/wconcept-ui-renewal/components/organisms/_section/RltdContentsSection';
import RltdCntntItem2 from '@wconcept/wconcept-ui-renewal/components/molecules/_item/RltdCntntItem2';
import { PromotionContentModule } from '@wconcept/wconcept-common/models/renewal/promotion';
import useLinkTo from '@hooks/useLinkTo';
import useGa4Event from '@hooks/useGa4Event';
import { type PromotionModuleVisualTokens } from '@utils/promotionContentVisual';
import { usePromotionModuleCustomColors } from '@hooks/promotion/usePromotionModuleCustomColors';

interface RelatedContentModuleProps {
  bgType: string;
  visualTokens: PromotionModuleVisualTokens;
  isDesktop: boolean;
  title: string;
  subTitle: string;
  promotionId?: number;
  promotionTitle?: string;
  relatedContentsData?: PromotionContentModule[];
}

function RelatedContentModule({
  bgType,
  visualTokens,
  isDesktop,
  title,
  subTitle,
  promotionId,
  promotionTitle,
  relatedContentsData,
}: RelatedContentModuleProps) {
  const { linkTo } = useLinkTo();
  const { sendGa4BannerClick } = useGa4Event();

  const { presetBgType, customColorsLite } = usePromotionModuleCustomColors({
    bgType,
    visualTokens,
    mask: 'twoField',
  });

  const sectionColorType = customColorsLite ?? presetBgType;

  if (!relatedContentsData?.length || relatedContentsData?.length < 2)
    return null;

  return (
    <RltdContentsSection
      colorType={sectionColorType}
      title={title}
      subTitle={subTitle}
      isDesktop={isDesktop}
    >
      {relatedContentsData?.map((v, index) => (
        <RltdCntntItem2
          key={v.moduleId}
          imgSrc={v.imageUrl}
          title={v.mainText}
          desc={v.subText}
          onClick={() => {
            const issueCd = v.landingUrl?.split('/').pop() || '';
            sendGa4BannerClick({
              area: 'promotion_contents_banner',
              page: 'promotion',
              issueCd,
              issueNm: promotionTitle,
              text: v.mainText,
              listNo: index + 1,
              bannerType: v.ga4ClickEventResponse?.eventType,
            });
            linkTo.push({
              url: v.landingUrl,
            });
          }}
        />
      ))}
    </RltdContentsSection>
  );
}

export default memo(RelatedContentModule);
